var render = function (_h,_vm) {var _c=_vm._c;return _c('span',{staticClass:"\n    tw-inline-block\n    tw-rounded\n    tw-items-center\n    tw-whitespace-nowrap\n    tw-px-1.5\n    tw-py-px\n    tw-text-xs\n    tw-font-semibold\n    tw-border-transparent\n    tw-text-white\n  ",class:[
    _vm.data.staticClass,
    _vm.data.class,
    ("tw-bg-" + (_vm.props.color ? _vm.props.color : 'gray-500')),
    ("tw-text-" + (_vm.props.textColor ? _vm.props.textColor : 'current')) ]},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }